import React from "react"
import EditorSection from "components/Builder/components/EditorSection"
import SidePanelHeader from "components/Builder/components/SidePanelHeader"
import { Text } from "@chakra-ui/react"
import PaddingInputs from "components/Builder/components/PaddingInputs"
import ColorSelect from "components/ReactHookForm/ColorSelect/ColorSelect"
import Select from "components/ReactHookForm/Select"
import SwitchField from "components/ReactHookForm/SwitchField"
import { Control, useWatch } from "react-hook-form"
import { useCurrentEvent } from "queries/events"
import { WALLET_BADGE_LANGUAGE_OPTIONS } from "utilities/walletPassBadges"

type Props = {
  control: Control
}

const WalletPassFields = ({ control }: Props) => {
  const { data: event } = useCurrentEvent()
  const localize = useWatch({ control, name: "localizeToEventLanguage" })

  // Send-time gating mirrors the confirmation emails, so surface the event-level
  // reasons the block would render nothing while there is still time to fix them.
  const walletPassOff = !event.includePassbook
  const temporalQrCodesOn = event.expiringQrCodes

  return (
    <>
      <SidePanelHeader>Wallet Pass Block</SidePanelHeader>
      <EditorSection>
        <Text mb={4}>
          The badges shown here are placeholders. Each guest receives their own Apple
          and Google Wallet links when the email is sent.
        </Text>
        {walletPassOff && (
          <Text mb={4} color="orange.500">
            Wallet Pass is turned off for this event, so this block will not appear in
            the sent email. Turn on “Include Apple Wallet and Google Wallet Badges” in
            Guest Confirmation Settings.
          </Text>
        )}
        {temporalQrCodesOn && (
          <Text mb={4} color="orange.500">
            Temporal QR Codes are on for this event, which disables wallet passes, so
            this block will not appear in the sent email.
          </Text>
        )}
      </EditorSection>
      <EditorSection>
        <SwitchField
          label="Automatically localize using event language"
          name="localizeToEventLanguage"
          control={control}
        />
        <Text mt={2} mb={4}>
          Badge images are shown in the event’s language. Turn this off to pick a
          specific language.
        </Text>
        <Select
          name="language"
          control={control}
          label="Language"
          options={WALLET_BADGE_LANGUAGE_OPTIONS}
          disabled={localize}
        />
      </EditorSection>
      <EditorSection>
        <PaddingInputs control={control} />
      </EditorSection>
      <EditorSection>
        <ColorSelect label="Block Color" name="blockColor" control={control} colorScheme="light" />
      </EditorSection>
    </>
  )
}

export default WalletPassFields
